import styled from 'styled-components'

const TagsListWrapper = styled.div`
  position: relative;
  display: block;
  width: 100%;
`
TagsListWrapper.displayName = 'TagsListWrapper'
export default TagsListWrapper
